import { createUseTableApiCall } from '@piaas/piaas-ui-toolkit/hooks';

import useApiQuery from './useApiQuery';

// Thin binding to the toolkit's React-Query-backed implementation - see
// `createUseTableApiCall` there for the caching behavior.
const useTableApiCall = createUseTableApiCall(useApiQuery);

export default useTableApiCall;
